import React, { useState, useEffect } from "react";
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from "../../../../columns/ib/MT5Account/MT5PendingAccounts.js";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import ConfirmationModal from "../../../../components/modals/ConfirmationModal.jsx";
import { GetAllAccountApi, MT5RequestAcceptRejectApi } from '../../../../api/request/liveAccount.js';
import toast from "react-hot-toast";
import moment from "moment";
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import { Form, Input } from 'antd';
import LoadableButton from '../../../../components/buttons/LoadableButton.jsx';
const { TextArea } = Input;

export default function Accounts({ dates }) {
    const [rejectForm] = Form.useForm();

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [mt5Accept, setMT5Accept] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [mt5Rejection, setMT5Rejection] = useState(false);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [selectedmt5, setSelectedMT5] = useState({ userId: null, mT5Id: null });
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

    const setSelectedMT5Id = (userId, mT5Id) => {
        setSelectedMT5({ userId, mT5Id });
    };

    const getPendingAccounts = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: dates,
                FilterText: "Pending",
                Sortby:'createdDate'
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        const { userId, mT5Id } = item;

                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
                            balance: `$ ${item?.balance}`,
                            actions: (
                                <div className="flex">
                                    <button
                                        className="mr-3 ml-3"
                                        onClick={() => {
                                            setSelectedMT5Id(userId, mT5Id);
                                            setMT5Accept(true);
                                        }}
                                    >
                                        <img src="/assets/icons/accept_icon.svg" alt="icon" width={27} />
                                    </button>
                                    <button onClick={() => {
                                        setSelectedMT5Id(userId, mT5Id);
                                        setMT5Rejection(true)
                                    }}><img src="/assets/icons/delete_icon.svg" alt="icon" width={27} /></button>
                                </div>
                            ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getPendingAccounts();
    }, [page, pageSize,dates, filter]);

    const MT5RequestHandlerApproved = async (value) => {
        if (!value) {
            if (!textAreaValue) {
                toast.error('Please enter a reason.');
                return;
            }
        }
        try {
            setIsReqLoading(true);
            let params = {
                isRejected: false,
                isApproved: true,
                comment: textAreaValue ? textAreaValue : 'Accepted.',
                userId: selectedmt5?.userId,
                mT5Id: selectedmt5?.mT5Id

            }
            const { data } = await MT5RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                // setIsOpenModal(false);
                getPendingAccounts();
                setTextAreaValue('');
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        if (value) {
            setMT5Accept(false);
        } else {
            setMT5Rejection(false);
        }
    }

    const MT5RequestHandlerRejected = async (value) => {
        

        if (!value) {
            toast.error('Please enter a reason.');
            return;
        }
        try {
            setIsReqLoading(true);
            let params = {
                isRejected: true,
                isApproved: false,
                comment: value.comment,
                userId: selectedmt5?.userId,
                mT5Id: selectedmt5?.mT5Id

            }
            const { data } = await MT5RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getPendingAccounts();
                setTextAreaValue('');
                setMT5Rejection(false);
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        if (value) {
            setMT5Accept(false);
        } else {
            setMT5Rejection(false);
        }
    }
    
    return (
        <div>

            <div className=" w-full">
                <div className="my-6">
                  <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                  </div>

                    <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>

            {/* ---- Accept-request ---- */}
            <ConfirmationModal
                isOpen={mt5Accept}
                setIsOpen={setMT5Accept}
                type='success'
                message='Are you sure you want to accept this request?'
                onConfirm={() => MT5RequestHandlerApproved(true)}
                isLoading={isReqLoading}
                loadingLabel='Accepting request...'
            />


            {/* Reject Account request modal */}
            <ModalComponent isOpen={mt5Rejection} setIsOpen={setMT5Rejection} title={'Are you sure you want to reject this request?'} width={600}>
                <Form form={rejectForm} initialValues={textAreaValue} onFinish={MT5RequestHandlerRejected}>
                    <label className='text-base text-[#2F2B3DCC] font-medium'>Reason of rejection</label>
                    <Form.Item name="comment" rules={[{ required: true, message: 'Please enter comment.' }]}>
                        <TextArea rows={4} placeholder='Describe reason...' />
                    </Form.Item>
                    <div className='flex items-center justify-end gap-5 mt-5'>
                        <button type='button' onClick={() => setMT5Rejection(false)} className='bg-secondary text-sm text-white font-semibold px-6 py-2 rounded-lg themeSecondaryHover duration-500'>Cancel</button>
                        <LoadableButton
                            type='submit'
                            className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
                            lable='Reject'
                            loadingLable='Rejecting request...'
                            isLoading={isLoadingSubmit}
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}